// extracted by mini-css-extract-plugin
export var phone = "_1y-0";
export var phoneDragging = "_1y-1";